import React, { useState, useEffect } from 'react';
import Icon from './Icon';
import './Toast.css';

const ICONS = { success: 'check', error: 'triangle-alert', info: 'info' };

/**
 * A short message that says what just happened (BRAND_SPEC §11.0, §9.5):
 * the pressed surface, a control edge, white Inter 500 16 px, an icon (never
 * colour alone), four seconds, announced politely. Fades in and out in
 * 160 ms; with reduced motion it simply appears and goes.
 */
function Toast({ message, type = 'success', duration = 4000, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let closeTimer = null;
    const timer = setTimeout(() => {
      setIsVisible(false);
      closeTimer = setTimeout(() => {
        if (onClose) onClose();
      }, 160);
    }, duration);

    return () => { clearTimeout(timer); clearTimeout(closeTimer); };
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 160);
  };

  return (
    <div
      className={`toast toast-${type} ${isVisible ? 'toast-visible' : 'toast-hidden'}`}
      role="status"
      aria-live="polite"
    >
      <div className="toast-content">
        <Icon name={ICONS[type] || 'info'} size={20} />
        <span className="toast-message">{message}</span>
        <button
          type="button"
          className="toast-close"
          onClick={handleClose}
          aria-label="Dismiss"
        >
          <Icon name="x" size={20} />
        </button>
      </div>
    </div>
  );
}

export default Toast;
